export default __webpack_public_path__ + "media/zurb/img/playground/onboarding-walkthroughs-22e52030b6f68d8216e32a2763fb759e.png";